// @flow
import Resource from 'speed-js-core/src/api/Resource';

export default class AuditEventTypeResource extends Resource {
    basePath: string = 'audit/events/types/';

    objectPath: string = 'audit/events/types/{ident}/';
}
